/**
 * Collection Filter Tabs — tab toggle + "More filter" trigger + sync with drawer
 */
(function () {
  var section = document.querySelector('.cft');
  if (!section) return;

  function trackClarity(name) {
    if (typeof window.clarity === 'function') {
      window.clarity('event', name);
    }
  }

  var sectionId = section.getAttribute('data-section-id');
  var tabs = section.querySelectorAll('.cft__tab');
  var panels = section.querySelectorAll('.cft__panel');
  var moreBtn = section.querySelector('.cft__more');

  function closeAll() {
    tabs.forEach(function (t) { t.classList.remove('is-open'); });
    panels.forEach(function (p) { p.classList.remove('is-open'); });
  }

  function bindFilterOptionTracking() {
    section.querySelectorAll('.cft__panel a[href]').forEach(function (link) {
      if (link.dataset.clarityBound) return;
      link.dataset.clarityBound = '1';
      link.addEventListener('click', function () {
        if (link.classList.contains('is-active')) {
          trackClarity('filter_cleared');
        } else {
          trackClarity('filter_option_selected');
        }
      });
    });
  }

  function bindTabs() {
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-target');
        var panel = section.querySelector('#' + target);
        var isOpen = tab.classList.contains('is-open');

        closeAll();

        if (!isOpen && panel) {
          tab.classList.add('is-open');
          panel.classList.add('is-open');
          var name = (target || '').replace('cft-panel-', '').toLowerCase();
          if (name === 'size') trackClarity('filter_open_size');
          else if (name === 'fit') trackClarity('filter_open_fit');
          else if (name === 'rise') trackClarity('filter_open_rise');
        }
      });
    });
  }

  bindTabs();
  bindFilterOptionTracking();

  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      closeAll();
      trackClarity('filter_open_more');
      var isMobile = window.innerWidth <= 767;
      if (isMobile && window.BSheet) {
        window.BSheet.open();
      } else {
        var drawer = document.getElementById('Facet-Drawer');
        if (drawer) {
          document.body.classList.add('open-cc');
          drawer.classList.add('active');
        }
      }
    });
  }

  document.addEventListener('click', function (e) {
    if (!section.contains(e.target)) {
      closeAll();
    }
  });

  // Sync filter tabs when URL changes (after drawer/bottom sheet filter applied)
  if (sectionId) {
    var originalPushState = history.pushState;
    history.pushState = function () {
      originalPushState.apply(this, arguments);
      refreshFilterTabs();
    };

    window.addEventListener('popstate', refreshFilterTabs);

    function refreshFilterTabs() {
      var url = window.location.pathname + window.location.search;
      var separator = url.indexOf('?') === -1 ? '?' : '&';
      var fetchUrl = url + separator + 'section_id=' + sectionId;

      fetch(fetchUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var newSection = parsed.querySelector('.cft');
          if (newSection && section.parentNode) {
            section.innerHTML = newSection.innerHTML;
            section.setAttribute('data-section-id', sectionId);
            // Re-bind tabs and panels
            tabs = section.querySelectorAll('.cft__tab');
            panels = section.querySelectorAll('.cft__panel');
            moreBtn = section.querySelector('.cft__more');

            bindTabs();
            bindFilterOptionTracking();

            if (moreBtn) {
              moreBtn.addEventListener('click', function () {
                closeAll();
                trackClarity('filter_open_more');
                var isMobile = window.innerWidth <= 767;
                if (isMobile && window.BSheet) {
                  window.BSheet.open();
                } else {
                  var drawer = document.getElementById('Facet-Drawer');
                  if (drawer) {
                    document.body.classList.add('open-cc');
                    drawer.classList.add('active');
                  }
                }
              });
            }
          }
        });
    }
  }
})();
